module.exports = __webpack_public_path__ + "img/IMG_8981_L_Black.fa323e89.jpg";